export default __webpack_public_path__ + "static/media/ashley-whitlatch-36aGnv29Ss0-unsplash.7fb32f17.jpg";